import React from 'react';
import SolutionUserInfoContainer from 'containers/SolutionUserInfoContainer';

export default function SolutionUserInfoPage() {
  return <SolutionUserInfoContainer />;
}
